<template>
  <div>
    <!------------------------------------------------------------------------
    The main modal for adding or editing an event.
    ------------------------------------------------------------------------->
    <a-modal
      :visible="visible"
      centered
      :title="edit_mode ? 'Edit Event' : 'New Event' "
      @cancel="closeModal"
      :width="700"
    >
      <ASpin :spinning="loading" :indicator="indicator">
        <a-form :form="form" @submit.prevent="createOrUpdate">
          <a-form-item label="Title" has-feedback>
            <a-input
              v-decorator="['title',{ rules: [{ required: true, message: 'this field is required.' }]}]"
              placeholder="Title"
            />
          </a-form-item>

          <div class="grid grid-cols-2 gap-2" :class="[ !is_checked_all_day ? 'md:grid-cols-4' : 'md:grid-cols-2' ]">
            <a-form-item label="Start date" has-feedback>
              <a-date-picker
                v-decorator="['start',{ rules: [
                    { required: true, message: 'this field is required.' },
                    { validator: (rule,value) => validateCheckDateFrom(value,'end'), required:true, message: 'The start date must be smaller than the end date.\n' }
                  ]}]"
                class="w-full"
                placeholder="dd/mm/yyyy"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
            <a-form-item label="Start time" has-feedback v-if="!is_checked_all_day">
              <a-time-picker
                class="w-full"
                format="h:mm A"
                valueFormat="HH:mm:ss"
                v-decorator="['time_start',{ rules: [{ required: true, message: 'this field is required.' }] }]"
                @change="selectStart"
              />
            </a-form-item>
            <a-form-item label="End date" has-feedback>
              <a-date-picker
                v-decorator="['end',{ rules: [
                    { required: true, message: 'this field is required.' },
                    { validator: (rule,value) => validateCheckDateTo(value,'start'), required:true , message: 'The end date must be greater than the start date.\n' }
                  ]}]"
                class="w-full"
                placeholder="dd/mm/yyyy"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
            <a-form-item has-feedback label="End time" v-show="!is_checked_all_day">
              <a-time-picker
                class="w-full"
                format="h:mm A"
                valueFormat="HH:mm:ss"
                v-decorator="['time_end',{ rules: [{ required: true, message: 'this field is required.' }] }]"
                @change="selectEnd"
              />
            </a-form-item>
          </div>

          <div class="flex space-x-3">
            <a-form-item class="self-end">
              <a-checkbox
                @change="onAllDayChanged"
                v-decorator="[
                    'is_all_day',
                    { valuePropName:'checked', rules: [{ required: false, message: 'this field is required.' }] }
                  ]"
              >
                All day
              </a-checkbox>
            </a-form-item>

            <!--            :checked="checked"-->

            <a-form-item class="self-end">
              <a-checkbox
                @change="onRepeatChanged"
                v-decorator="['repeat_allow',{ valuePropName:'checked',rules: [{ required: false}] }]"
              >
                Repeat
              </a-checkbox>
            </a-form-item>
          </div>

          <div class="flex items-center" v-if="edit_mode && row && row.repeat_allow">
            <div class="font-bold">Summery:</div>
            <div class="font-normal ml-1">
              Repeat every
              {{ (form.getFieldValue('repeat_every') || row && row.repeat_every) === 1 ? '' : form.getFieldValue('repeat_every') || row.repeat_every }}
              {{ selectRepeatType(form.getFieldValue('repeat_type') || (row ? row.repeat_type : null)) }}
              {{ days_of_months_repeat(form.getFieldValue('in_repeat_monthly_repeat_on_day_of_month') || (row ? row.in_repeat_monthly_repeat_on_day_of_month : null))}}
              {{ value_type_end(form.getFieldValue('type_end_date') || (row ? row.type_end_date : null)) }}
              <a-button type="link" class="p-0 self-center" @click="RepeatEditEvent(row)">Edit</a-button>
            </div>
          </div>

          <a-form-item label="Location" has-feedback>
            <a-input
              v-decorator="['location',{ rules: [{ required: false, message: 'this field is required.' }] }]"
              placeholder="Location"
            />
          </a-form-item>

          <SelectOption
            url="/account/list/"
            label="Attendees"
            field="for_users"
            :required="true"
            method="get"
            mode="multiple"
            placeholder="Find A User"
            class="w-full"
          />

          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['is_for_firm',{ valuePropName:'checked', rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Add this event to the Firm calendar
            </a-checkbox>
          </a-form-item>

          <selectSearch
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            class="self-center mt-8 md:mt-0 w-full"
            :is_include_matter="true"
            @selectSearch="handleSearch"
          />

          <a-form-item label="Priority" has-feedback>
            <a-select v-decorator="['labels',{ initialValue: 1,rules: [{ required: false }] }]">
              <a-select-option v-for="(label, index) in calendarLabels" :value="label.value">
                <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                <span>{{ label.text }}</span>
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Tags" has-feedback>
            <a-select
              mode="tags"
              style="width: 100%"
              placeholder="Enter your tags"
              v-decorator="['tags']"
            >
              <a-select-option v-for="(tag,index) in tags" :key="index">
                {{ tag }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-divider/>

          <RemindersComponent
            ref="reminder"
            @addReminder="onReminderAdded"
            @removeReminder="onReminderRemoved"
            @changeOptionDate="onReminderDateChanged"
          />
          <a-divider/>

          <a-form-item label="Description" has-feedback>
            <a-textarea
              v-decorator="['description',{ rules: [{ required: false, message: 'Please input your username!' }] }]"/>
          </a-form-item>

          <a-divider/>

          <div class="flex justify-between space-x-2">
            <div class="space-x-2">
              <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
                Save event
              </a-button>
              <a-button type="primary" ghost @click="closeModal" style="border-radius: 3px !important;">
                Cancel
              </a-button>
            </div>
          </div>
        </a-form>
      </ASpin>
    </a-modal>

    <!------------------------------------------------------------------------
    The auxiliary modal for editing the event repeats.
    ------------------------------------------------------------------------->
    <a-modal
      centered
      title="Repeat this event"
      :visible="repeatsVisible"
      @cancel="repeatsVisible = false"
      :width="700"
    >
      <a-form :form="form">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <a-form-item label="Repeat" has-feedback>
            <a-select
              allowClear
              @select="selectRepeatType"
              class="select"
              v-decorator="['repeat_type',{rules: [{ required: form.getFieldValue('repeat_allow'), message: 'This field is required.' }] }]"
            >
              <a-select-option :value="1">
                Daily
              </a-select-option>
              <a-select-option :value="2">
                Weekly
              </a-select-option>
              <a-select-option :value="3">
                Monthly
              </a-select-option>
              <a-select-option :value="4">
                Yearly
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Every">
            <a-input-number :min="1" v-decorator="['repeat_every',{ initialValue: 1,rules: [{ required: false, message: 'This field is required.' }] }]" style="border-radius: 3px !important;"/>
            {{ selectRepeatType(form.getFieldValue('repeat_type')) || 'Day(s)' }}
          </a-form-item>

          <div v-if="form.getFieldValue('repeat_type') === 3" class="flex">
            <a-form-item class="self-end">
              On
              <a-input-number
                :min="1"
                :max="31"
                v-decorator="['in_repeat_monthly_repeat_on_day_of_month',{ initialValue: row && row.in_repeat_monthly_repeat_on_day_of_month ? row.in_repeat_monthly_repeat_on_day_of_month: null ,rules: [{ required: false, message: 'This field is required.' }] }]" style="border-radius: 3px !important;"
              />
              <!--              :max="maxDaysRepeat(form.getFieldValue('start'))"-->
              day(s)
            </a-form-item>
          </div>
          <!--          <div v-else-if="form.getFieldValue('repeat_type') === 2">-->
          <!--            <a-form-item label="Day of The Week:" class="self-end">-->
          <!--              <a-select v-decorator="['labels',{ initialValue: 1,rules: [{ required: false }] }]">-->
          <!--                <a-select-option v-for="(label, index) in calendarLabels" :value="label.value">-->
          <!--                  <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>-->
          <!--                  <span>{{ label.text }}</span>-->
          <!--                </a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </div>-->

        </div>

        <!--        <div class="flex justify-center space-x-2 mt-5" v-if="form.getFieldValue('repeat_type') === 2">-->
        <!--          <div class="flex space-x-2 mt-5" v-if="false">-->
        <div class="flex space-x-2 mt-5" v-if="form.getFieldValue('repeat_type') === 2">
          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['in_repeat_weekly_repeat_on_monday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Mo
            </a-checkbox>
          </a-form-item>
          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['in_repeat_weekly_repeat_on_tuesday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Tu
            </a-checkbox>
          </a-form-item>
          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['in_repeat_weekly_repeat_on_wednesday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              We
            </a-checkbox>
          </a-form-item>
          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['in_repeat_weekly_repeat_on_thursday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Th
            </a-checkbox>
          </a-form-item>
          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['in_repeat_weekly_repeat_on_friday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Fr
            </a-checkbox>
          </a-form-item>
          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['in_repeat_weekly_repeat_on_saturday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Sa
            </a-checkbox>
          </a-form-item>
          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['in_repeat_weekly_repeat_on_sunday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Su
            </a-checkbox>
          </a-form-item>
        </div>

        <a-divider/>

        <h4>End</h4>

        <div class="flex flex-col items-end md:flex-row ml-16">
          <a-form-item>
            <a-radio-group @change="selectTypeRepeatEnd" class="flex flex-col" v-decorator="['type_end_date',{ initialValue: InitialValueTypeEndDate, rules: [{ required: false, message: 'This field is required.' }] }]">
              <a-radio :style="{display: 'block',height: '40px',lineHeight: '30px'}" :value="1">
                Never
              </a-radio>
              <a-radio :style="{display: 'block',height: '40px',lineHeight: '30px'}" :value="2">
                After
              </a-radio>
              <a-radio :style="{display: 'block',height: '40px',lineHeight: '30px'}" :value="3">
                On
              </a-radio>
            </a-radio-group>
          </a-form-item>

          <div class="flex flex-col">
            <a-form-item class="pb-2">
              (until the end of the year)
            </a-form-item>
            <a-form-item >
              <a-input-number :disabled="form.getFieldValue('type_end_date') !== 2" :min="1" v-decorator="['repeat_end_after_occurrence',{ rules: [{ required: false, message: 'This field is required.' }] }]" style="border-radius: 3px !important;"/>
              occurrence(s)
            </a-form-item>
            <a-form-item>
              <a-date-picker
                :disabled="form.getFieldValue('type_end_date') !== 3"
                v-decorator="['repeat_end_date',{ rules: [{ required: false, message: 'This field is required.' }] }]"
                style="border-radius: 3px !important;"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD[T]HH:mm:ss"
              />
            </a-form-item>
          </div>

        </div>

        <a-divider/>

        <div class="flex">
          <div class="font-bold">Summery:</div>
          <div class="font-normal ml-1">
            Repeat every
            {{ form.getFieldValue('repeat_every') <= 1 ? '' : form.getFieldValue('repeat_every') }}
            {{ selectRepeatType(form.getFieldValue('repeat_type')) }}
            {{ days_of_months_repeat(form.getFieldValue('in_repeat_monthly_repeat_on_day_of_month')) }}
            {{ value_type_end(form.getFieldValue('type_end_date')) }}
          </div>
        </div>

        <a-divider/>

        <div class="flex justify-between space-x-2">
          <div class="space-x-2">
            <a-button type="primary" @click="saveRepeats" style="border-radius: 3px !important;">
              Save
            </a-button>
            <a-button type="primary" ghost @click="repeatsVisible = false" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import axios from '@/axios'
import moment from 'moment'
import mixin from '../mixin/mixin'
import RemindersComponent from "@/views/reminders/RemindersComponent"
import SelectOption from "../forms/SelectOptionSingle"
import selectSearch from "@/views/forms/selectSearch"

export default {
  name: 'CalendarEventFormComponent',

  mixins: [mixin],

  components: {
    RemindersComponent,
    SelectOption,
    selectSearch,
  },

  props: {
    // The v-model controls the visibility of the modal.
    value: {
      type: Boolean,
      required: false,
      default: false,
    },

    // Whether the calendar event should be updated or created.
    edit_mode: {
      type: Boolean,
      required: false,
      default: false,
    },

    event_id: {
      type: Number,
      required: false,
      default: -1,
    },
  },

  data() {
    return {
      // Whether the modal is visible or not.
      // It is the mutable backup for props.value.
      visible            : false,
      repeatsVisible     : false,
      is_checked_all_day : false,
      loading            : false,
      indicator          : <a-icon type="loading" style="font-size: 36px" spin />,
      time_start         : null,
      time_end           : null,
      tags               : [],

      // TODO: Seems like it is not used anywhere in the code. If also not in
      // the template, then remove it and all its occurences.
      checked            : false,

      // The calendar event data that is received from the server to initialize
      // the form in the edit mode.
      row                : undefined,
      temp_row           : undefined,
      calendarLabels     : [
      { value: 4, text: 'Urgent', color: 'danger'  },
      { value: 3, text: 'High',   color: 'warning' },
      { value: 1, text: 'Normal', color: 'primary' },
      { value: 2, text: 'Low',    color: 'success' },
    ],
  }
  },

  watch: {
    value: function(val) {
      if (val) {
        if (this.edit_mode) this.openModalForEditing()
        else this.openModalForCreating()
      }
      else this.closeModal()
    },
  },

  mounted() {
    if (this.value) {
      if (this.edit_mode) this.openModalForEditing()
      else this.openModalForCreating()
    }
  },

  // hasPermission('calendar.event.edit')

  methods: {
    // If the client doesn't have the permission to create calendar events, the
    // modal should refuse to show up.
    openModalForCreating() {
      if (this.hasPermission('calendar.event.create')) {
        this.visible = this.value
        this.is_checked_all_day = false
        let now = new moment();
        this.form.resetFields()
        this.$nextTick(() => this.form.setFieldsValue({
          start      : moment(new Date()).format('YYYY-MM-DD'),
          end        : moment(new Date()).format('YYYY-MM-DD'),
          time_start : now.format('HH:mm:ss'),
          time_end   : now.add(1, 'hours').format('HH:mm:ss'),
        }))
      }
    },

    async openModalForEditing() {
      try {
        this.loading = true
        const { data } = await axios.get(`/calendar/event/${this.event_id}/`)
        this.visible = true
        const start = data.start.split('T')
        const end = data.end.split('T')
        data.for_users = data.for_users.map(item=>item.id)
        data.matter ? data.matter = data.matter.title : data.matter = undefined
        data.time_start = start[start.length - 1]
        data.time_end   = end[end.length - 1]
        data.repeat_type !== -1 ? data.repeat_allow = true : data.repeat_allow = false
        if (data.repeat_type === -1) data.repeat_type = undefined
        data.is_all_day === true ? this.is_checked_all_day = true : this.is_checked_all_day = false
        data.labels = data.labels ? Number(`${data.labels}`) : 1
        data.tags   = data.tags !== '[]' && data.tags ? data.tags.slice(1, -1).split(',').map(item=>item.replace(/['"]+/g, '')) : []
        data.repeat_end_after_occurrence ? data.type_end_date = 2 : data.repeat_end_date ? data.type_end_date = 3 : data.type_end_date = 1
        if (data.reminders && data.reminders.length)
          this.$refs.reminder.reminders = data.reminders.map(item => ({ target_date: item.target_date, notification_type: item.notification_type }))
        this.row = data
        this.$nextTick(() => this.form.setFieldsValue(data))
      } catch (e) {
        console.log("ERROR", e)
        this.$notification['error']({
          message: 'error',
          description: `Calender item failed.`,
        })
        this.closeModal()
      } finally {
        this.loading = false
      }
    },

    closeModal() {
      this.visible = false
      this.$emit('input', false)
      this.is_checked_all_day = false
      if (this.edit_mode) {
        this.form.resetFields()
        this.row = undefined
      }
    },

    selectStart(time, timeString){
      this.time_start = timeString
    },

    selectEnd(time, timeString){
      this.time_end = timeString
    },

    selectRepeatType(value) {
      if(value === 1) return 'Day(s)'
      else if(value === 2) return 'Week(s)'
      else if(value === 3) return 'Month(s)'
      else if(value === 4) return 'Year(s)'
    },

    onAllDayChanged({ target: { checked } }) {
      this.is_checked_all_day = checked
    },

    onRepeatChanged({ target:{checked} }){
      this.checked = checked
      const {row} = this
      if (checked) {
        this.RepeatEditEvent(row)
      }else
        this.repeatsVisible = false
    },

    RepeatEditEvent(row){
      this.repeatsVisible = true
      if (this.edit_mode && row) {
        this.$nextTick(() => this.form.setFieldsValue({
          repeat_end_date               : this.form.getFieldValue('repeat_end_date')  || row.repeat_end_date,
          repeat_every                  : this.form.getFieldValue('repeat_every')     || row.repeat_every,
          repeat_type                   : this.form.getFieldValue('repeat_type')      || row.repeat_type,
          repeat_end_after_occurrence   : this.form.getFieldValue('repeat_end_after_occurrence') || row.repeat_end_after_occurrence,
          in_repeat_weekly_repeat_on_monday : this.form.getFieldValue('in_repeat_weekly_repeat_on_monday') || row.in_repeat_weekly_repeat_on_monday,
          in_repeat_weekly_repeat_on_tuesday : this.form.getFieldValue('in_repeat_weekly_repeat_on_tuesday') || row.in_repeat_weekly_repeat_on_tuesday,
          in_repeat_weekly_repeat_on_wednesday : this.form.getFieldValue('in_repeat_weekly_repeat_on_wednesday') || row.in_repeat_weekly_repeat_on_wednesday,
          in_repeat_weekly_repeat_on_thursday : this.form.getFieldValue('in_repeat_weekly_repeat_on_thursday') || row.in_repeat_weekly_repeat_on_thursday,
          in_repeat_weekly_repeat_on_friday : this.form.getFieldValue('in_repeat_weekly_repeat_on_friday') || row.in_repeat_weekly_repeat_on_friday,
          in_repeat_weekly_repeat_on_saturday : this.form.getFieldValue('in_repeat_weekly_repeat_on_monday') || row.in_repeat_weekly_repeat_on_saturday,
          in_repeat_weekly_repeat_on_sunday : this.form.getFieldValue('in_repeat_weekly_repeat_on_sunday') || row.in_repeat_weekly_repeat_on_sunday,
        }))
      }
    },

    saveRepeats() {
      if (!this.form.getFieldValue('repeat_type')) {
        this.$message.error('field Repeat is required.')
        return
      }
      if (!this.form.getFieldValue('repeat_every')) {
        this.$message.error('field Repeat every is required.')
        return
      }
      this.repeatsVisible = false
    },

    selectTypeRepeatEnd({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({repeat_end_after_occurrence: null, repeat_end_date: null})
      else if(value === 2)
        this.form.setFieldsValue({repeat_end_date: null,repeat_end_after_occurrence: (this.row && this.row.repeat_end_after_occurrence) ? this.row.repeat_end_after_occurrence : 1})
      else
        this.form.setFieldsValue({repeat_end_after_occurrence: null,repeat_end_date: (this.row && this.row.repeat_end_date) ? this.row.repeat_end_date : moment().format('YYYY-MM-DD')})
    },

    days_of_months_repeat(val) {
      const {row} = this
      const theDate = new Date() // originally, it was this.showDate
      if((this.form.getFieldValue('repeat_type') || row && row.repeat_type) === 3){
        if(val){
          const date = `${moment(theDate.toISOString()).format('YYYY')}-${moment(theDate.toISOString()).format('MM')}-${val < 10 ? '0' + val : val}`
          return `on the ${moment(date).format('Do')}` || ''
        } else if (val === null || val === '') {
          return ``
        } else if(row && row.in_repeat_monthly_repeat_on_day_of_month) {
          const date = `${moment(this.form.getFieldValue('start')).format('YYYY')}-${moment(this.form.getFieldValue('start')).format('MM')}-${row.in_repeat_monthly_repeat_on_day_of_month < 10 ? '0' + row.in_repeat_monthly_repeat_on_day_of_month : row.in_repeat_monthly_repeat_on_day_of_month}`
          return `on the ${moment(date).format('Do')}` || ''
        }
      }
    },

    value_type_end(value) {
      const {row} = this
      const field_or_row = this.form.getFieldValue('repeat_end_date') || row && row.repeat_end_date
      if(value === 2)
        return `for ${this.form.getFieldValue('repeat_end_after_occurrence') || row && row.repeat_end_after_occurrence} times`
      if (value === 3)
        return field_or_row ? `until ${moment(field_or_row).format('MMMM Do YYYY')}` : undefined
    },

    // -------------------------------------------------------------------------
    // REMINDER METHODS

    onReminderRemoved(ind) {
      const reminders = this.form.getFieldValue('reminders')
      this.form.setFieldsValue({
        reminders: reminders.filter((reminder,index) => index !== ind)
      });
      this.$refs.reminder.reminders.splice(ind,1)
    },

    onReminderAdded() {
      if (this.form.getFieldValue('start'))
        this.$refs.reminder.reminders.push({
          target_date: undefined,
          notification_type: undefined
        })
      else this.$message.error('Please enter the start date field.')
    },

    onReminderDateChanged(date, i) {
      const start = this.form.getFieldValue('start')
      if (start) {
        this.form.setFieldsValue({
          [`reminders[${i}].target_date`]: moment(start).subtract(date, 'days').format('YYYY-MM-DD[T]HH:mm:ss')
        })
      }
    },

    // -------------------------------------------------------------------------
    // REQUESTS

    createOrUpdate() {
      this.form.validateFields(async (err, values) => {
        if(!err) {
          try {
            this.loading = true

            values.in_repeat_weekly_repeat_on_monday    = values.in_repeat_weekly_repeat_on_monday    || false
            values.in_repeat_weekly_repeat_on_tuesday   = values.in_repeat_weekly_repeat_on_tuesday   || false
            values.in_repeat_weekly_repeat_on_wednesday = values.in_repeat_weekly_repeat_on_wednesday || false
            values.in_repeat_weekly_repeat_on_thursday  = values.in_repeat_weekly_repeat_on_thursday  || false
            values.in_repeat_weekly_repeat_on_friday    = values.in_repeat_weekly_repeat_on_friday    || false
            values.in_repeat_weekly_repeat_on_saturday  = values.in_repeat_weekly_repeat_on_saturday  || false
            values.in_repeat_weekly_repeat_on_sunday    = values.in_repeat_weekly_repeat_on_sunday    || false

            values.repeat_allow  = undefined
            values.type_end_date = undefined
            values.repeat_end_date = values.repeat_end_date ? moment(values.repeat_end_date).format('YYYY-MM-DD[T]HH:mm:ss') : null
            if(values.reminders && values.reminders.length)
              values.reminders = values.reminders.filter(reminder => reminder.notification_type !== undefined && reminder.target_date !== undefined).map((item) =>({notification_type: item.notification_type, target_date: item.target_date}))
            if (this.edit_mode) {
              if(!this.is_checked_all_day){
                values.start = `${values.start.slice(0,10)}T${this.time_start ? this.time_start : values.time_start}`
                values.end   = `${values.end.slice(0,10)}T${this.time_start ? this.time_end : values.time_end}`
              }else{
                const start  = moment(new Date(values.start)).format('YYYY-MM-DD[T]HH:mm:ss')
                const end    = moment(new Date(values.end)).format('YYYY-MM-DD[T]HH:mm:ss')
                values.start = start
                values.end   = end
              }
              values.time_start = undefined
              values.time_end = undefined
              this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.row.matter.id
              if(values.repeat_type && values.repeat_type !== 3)
                values.in_repeat_monthly_repeat_on_day_of_month = null
              await axios.put(`/calendar/event/${this.event_id}/`,values)
            } else {
              if(!this.is_checked_all_day){
                values.start = `${values.start}T${values.time_start}`
                values.end   = `${values.end}T${values.time_end}`
              } else {
                const start  = moment(new Date(values.start)).format('YYYY-MM-DD[T]HH:mm:ss')
                const end    = moment(new Date(values.end)).format('YYYY-MM-DD[T]HH:mm:ss')
                values.start = start
                values.end   = end
              }
              values.time_start = undefined
              values.time_end = undefined
              await axios.post('/calendar/event/',values)
            }
            this.visible = false
            this.$emit('input', false)
            this.form.resetFields()
            this.is_checked_all_day = false
            this.$emit('success')
            this.$notification['success']({
              message: 'Success',
              description: `Calender event ${this.edit_mode ? 'updated' :'created'}.`,
            });
          } catch (e) {
            this.$notification['error']({
              message: 'error',
              description: (this.edit_mode)
                ? 'Failed to update the calendar event. Please try again.'
                : 'Failed to create the calendar event. Please try again.',
            });
            this.visible = true
          } finally {
            this.loading = false
          }
        }
      })
    },
  },

  computed: {
    InitialValueTypeEndDate() {
      if (this.edit_mode) {
        if (this.form.getFieldValue('repeat_end_date') || (this.row && this.row.repeat_end_date))
          return 3
        else if (this.form.getFieldValue('repeat_end_after_occurrence') || (this.row && this.row.repeat_end_after_occurrence))
          return 2
        else
          return 1
      }
      return 1
    },
  },
}
</script>
